import type { TradingViewChartWidgetModel } from '@thinkalpha/ui-types/contracts/workspace';
import type { TradingViewChartActions } from 'src/store/actions/widgets/tradingViewChart';
import type { WidgetTabViewModel } from 'src/store/types';

export const tradingViewChartReducer = (
    state: WidgetTabViewModel<TradingViewChartWidgetModel>,
    action: TradingViewChartActions,
): WidgetTabViewModel<TradingViewChartWidgetModel> => {
    switch (action.type) {
        case 'updateTradingViewChartSymbol':
        case 'changeTradingViewChartSymbol': {
            // Don't create new state if symbol hasn't changed - prevents infinite re-renders
            if (state.widget.symbol === action.symbol) {
                return state;
            }
            return {
                ...state,
                widget: {
                    ...state.widget,
                    symbol: action.symbol,
                },
            };
        }

        case 'updateTradingViewChartState': {
            return {
                ...state,
                widget: {
                    ...state.widget,
                    chartState: action.chartState,
                    interval: action.interval,
                    timezone: action.timezone,
                },
            };
        }

        default:
            return state;
    }
};
